import {Injectable} from '@angular/core';
import {Question} from '../../data/models/test/question';
import {HttpClient} from '@angular/common/http';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  constructor(
    private http: HttpClient,
  ) {
  }

  addQuestion(testId: number, position: number, data: {
    typeId: number,
    text: string,
    category: string,
    imageFile?: File,
    minAnswers?: number,
    maxAnswers?: number,
  }): Promise<Question> {

    const formData = new FormData();
    formData.append('typeId', data.typeId.toString());
    formData.append('text', data.text);
    formData.append('position', position.toString());
    if (data.category) {
      formData.append('category', data.category);
    }
    if (data.minAnswers !== undefined) {
      formData.append('minSelectedOptions', data.minAnswers.toString());
    }
    if (data.maxAnswers !== undefined) {
      formData.append('maxSelectedOptions', data.maxAnswers.toString());
    }
    if(data.imageFile){
        formData.append('imageFile', data.imageFile);
    }

    return this.http.post<Question>(`api/tests/${testId}/questions`, formData)
      .toPromise()
      .then(question => this.mapQuestion(question));
  }


  getQuestions(testId: number): Promise<Question[]> {
    return this.http.get<Question[]>(`api/tests/${testId}/questions`)
      .toPromise()
      .then(questions => questions.map(question => this.mapQuestion(question)));
  }

  getImage(imageName: string): Observable<Blob> {
      return this.http.get(`api/tests/questions/getImage/${imageName}`, { responseType: 'blob' });
  }

  updateQuestion(testId: number, questionId: number, newData: {
    text?: string,
    position?: number,
    typeTechId?: string,
    category?: string,
    correctOptionIds?: Number[],
    imageFile?: File,
    minAnswers?: number,
    maxAnswers?: number,
  }): Promise<Question> {

    const formData = new FormData();
    if (newData.text) {
      formData.append('text', newData.text);
    }
    if (newData.position) {
      formData.append('position', newData.position.toString());
    }
    if (newData.typeTechId) {
      formData.append('typeTechId', newData.typeTechId);
    }
    if (newData.category) {
        formData.append('category', newData.category);
    }
    if (newData.correctOptionIds) {
      formData.append('correctOptionIds', JSON.stringify(newData.correctOptionIds));
    }
    if (newData.minAnswers !== undefined) {
      formData.append('minSelectedOptions', newData.minAnswers.toString());
    }
    if (newData.maxAnswers !== undefined) {
      formData.append('maxSelectedOptions', newData.maxAnswers.toString());
    }
    if (newData.imageFile) {
      formData.append('imageFile', newData.imageFile);
    }

    return this.http.put<Question>(`api/tests/${testId}/questions/${questionId}`, formData)
      .toPromise()
      .then(question => this.mapQuestion(question));
  }

  deleteQuestion(testId: number, questionId: number): Promise<void> {
    return this.http.delete<void>(`api/tests/${testId}/questions/${questionId}`)
      .toPromise();
  }

  private mapQuestion(question: any): Question {
    const mappedQuestion: any = {...question};
    if (mappedQuestion.minAnswers === undefined) {
      mappedQuestion.minAnswers = mappedQuestion.minSelectedOptions ?? null;
    }
    if (mappedQuestion.maxAnswers === undefined) {
      mappedQuestion.maxAnswers = mappedQuestion.maxSelectedOptions ?? null;
    }
    delete mappedQuestion.minSelectedOptions;
    delete mappedQuestion.maxSelectedOptions;
    return mappedQuestion as Question;
  }
}
